"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var color_1 = __importDefault(require("color"));
var material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    var _a, _b, _c;
    return (0, styles_1.makeStyles)({
        root: __assign(__assign({}, material_kit_pro_react_1.container), { display: 'flex', flex: 1, flexDirection: 'column' }),
        menu: (_a = {
                display: 'flex'
            },
            _a[theme.breakpoints.up('sm')] = {
                alignItems: 'center',
                flexDirection: 'row'
            },
            _a[theme.breakpoints.down('xs')] = {
                flexDirection: 'column'
            },
            _a),
        menuHeader: {
            marginTop: theme.spacing(),
            marginBottom: theme.spacing(),
            marginLeft: theme.spacing(2)
        },
        menuSelectSection: (_b = {
                width: '100%',
                padding: 8
            },
            _b[theme.breakpoints.down('xs')] = {
                paddingBottom: theme.spacing(2),
                paddingRight: theme.spacing(2)
            },
            _b),
        menuSelect: {
            width: '100%',
            '& div': {
                padding: theme.spacing(2)
            }
        },
        grid: (_c = {
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(2)
            },
            _c[theme.breakpoints.up('lg')] = {
                flexDirection: 'row',
                marginBottom: theme.spacing(2)
            },
            _c[theme.breakpoints.only('md')] = {
                flexDirection: 'row',
                marginBottom: theme.spacing(10)
            },
            _c[theme.breakpoints.between('md', 'lg')] = {
                marginBottom: theme.spacing(12)
            },
            _c[theme.breakpoints.between('sm', 'md')] = {
                marginBottom: theme.spacing(12)
            },
            _c[theme.breakpoints.down('xs')] = {
                flexDirection: 'column',
                marginBottom: theme.spacing(1)
            },
            _c),
        pageHeader: {
            marginBottom: theme.spacing()
        },
        greenText: {
            color: theme.palette.success.main
        },
        page: {
            height: '100%',
            padding: theme.spacing(3),
            backgroundColor: theme.palette.background.default
        },
        selectedListItem: {
            backgroundColor: "".concat((0, color_1.default)(theme.palette.primary.main)
                .mix((0, color_1.default)(theme.palette.common.white), 0.9)
                .string(), " !important")
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map